import sleep from 'utils/sleep'
import { OperationError } from '../common/error'

export let list = async => [
  {
    title: '个人成果申报说明',
    status: '1',
    department: '信息中心',
    admin: '我',
    content: '个人成果申报功能已经上线，请老师按要求及时上传自己的成果，包括指导学生获奖、课题及论文获奖、教师本人获奖、论文发表、著作，公共5个类别的成果申报。\n成果申报页面进入方式：文件上传 - 个人成果上传',
    attachment: [],
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-8-28',
    uid: '100',
  },
]

export let list_brief = async => [
  {
    title: '个人成果申报说明',
    status: '1',
    department: '信息中心',
    admin: '我',
    content: '个人成果申报功能已经上线，请老师按要求及时上传自己的成果，包括指导学生获奖、课题及论文获奖、教师本人获奖、论文发表、著作，公共5个类别的成果申报。\n成果申报页面进入方式：文件上传 - 个人成果上传',
    attachment: [],
    receiver: ['教师', '管理', '校长', '教育部', '校长办公室'],
    pubdate: '2017-8-28',
    uid: '100',
  },
]

export let file = async => [
  {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  }, {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  },
]

export let file_brief = async => [
  {
    filename: 'xxxxx.pdf',
    updatetime: '2017-3-7',
    size: '34.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.png',
    updatetime: '2017-3-7',
    size: '12.3MB',
    department: '校长办公室',
    uploader: '杨杨',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uid: '100',
  },
  {
    filename: 'xxxxx.xls',
    updatetime: '2017-3-7',
    size: '0.3MB',
    department: '校长办公室',
    url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo/logo_white_fe6da1ec.png',
    uploader: '杨杨',
    uid: '100',
  },
]
export let notice_form_all = async => [
  {name: '标题', required: true, type: 'string', prop: 'title'},
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布人', type: 'string', prop: 'admin'},
  {name: '发布时间', type: 'date', prop: 'pubdate'},
  {name: '内容', type: 'string', prop: 'content'},
  {name: '接收人', type: 'select', prop: 'receiver'},
  {name: '附件', type: 'file', prop: 'attachment'},
]

export let notice_form_brief = async => [
  {name: '标题', required: true, type: 'string', prop: 'title'},
  {name: '发布部门', type: 'select', prop: 'department', select: ['教育部', '教务部', '校长办公室']},
  {name: '发布时间', type: 'date', prop: 'pubdate'},
]

export let file_form_brief = async => [
  {name: '文件', type: 'string', prop: 'filename'},
  {name: '更新时间', type: 'string', prop: 'updatetime'},
  {name: '大小', type: 'string', prop: 'size'},
  {name: '部门', type: 'string', prop: 'department'},
  {name: '下载', type: 'string', prop: 'url'},
]

export let file_form_all = async => [
  {name: '文件', type: 'string', prop: 'filename'},
  {name: '更新时间', type: 'string', prop: 'updatetime'},
  {name: '大小', type: 'string', prop: 'size'},
  {name: '部门', type: 'string', prop: 'department'},
  {name: '上传人', type: 'string', prop: 'uploader'},
  {name: '', type: 'string', prop: 'url'},
]

export let get_notice_detail = async uid => {
  let details = await list()
  for (let detail of details) {
    if (detail.uid === uid) return detail
  }
  throw new OperationError('获取列表错误')
}

export let set_notice_detail = async item => {
  // '1'未读 '0'已读
  item.status = '1'
}

export let onlySave = async (notice, notice_uid) => {
  await sleep(500)
  if (notice_uid) {
    return notice_uid
  } else {
    throw new OperationError('保存错误')
  }
}

export let set_file = async form => {
  await sleep(500)
}

export let get_department = async () => {
  await sleep(500)
  return [
    {uid: '100', name: '校长办公室'},
    {uid: '101', name: '教育处'},
  ]
}



// WEBPACK FOOTER //
// ./src/api/home.js